import * as React from "react";
const SvgArrowDownIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 6, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "#0C1114", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "m1 1 4 4 4-4" }));
export default SvgArrowDownIcon;
